import Vue from 'vue'
import Router from 'vue-router'

import LoginType from '../components/LoginType'
import Login from '../components/Login'
import User from '../components/User'
import Parent from '../components/Parent'
import Student from '../components/Student'
import StudentAdd from '../components/StudentAdd'
import Teacher from '../components/Teacher'
import Index from '../components/Index'
import StudentIndex from '../components/StudentIndex'
import WeChat from '../components/WeChatList'
import StudentLocus from '../components/StudentLocus'
import StudentLeave from '../components/StudentLeave'
import StudentLeaveAdd from '../components/StudentLeaveAdd'
import StudentGoBack from '../components/StudentGoBack'
import WGlist from '../components/WGlist'
// import WGmessage from '../view/WGmessage'
import UserInfo from '../components/UserInfo.vue'
import WeChatBack from '../components/WeChatBack'
import Err from '../components/err'
import UserImg from '../components/UserImg'
import MyStudent from '../components/MyStudent'
// import chidao from '../components/chidao'
// import windex from '../components/Windex'

const originalPush = Router.prototype.push
Router.prototype.push = function push(localhost) {
    return originalPush.call(this, localhost).catch(err => err)
}

Vue.use(Router)

const routes = [{
        path: '/',
        redirect: ''
    },
    {
        name:'LoginType',
        path: '/LoginType',
        component: LoginType
    },
    {
        path: '/Login',
        component: Login
    },
    {
        path: '/Index',
        component: Index
    },
    {
        path: '/StudentIndex',
        component: StudentIndex
    },
    {
        path: '/User',
        component: User
    },
    {
        path: '/Student',
        component: Student
    },
    {
        path: '/StudentAdd',
        component: StudentAdd
    },
    {
        path: '/Teacher',
        component: Teacher
    },
    {
        path: '/Parent',
        component: Parent
    },
    {
        path: '/WeChat',
        component: WeChat
    },
    {
        path: '/StudentLocus',
        component: StudentLocus
    },
    {
        path: '/StudentLeave',
        component: StudentLeave
    },
    {
        path: '/StudentLeaveAdd',
        component: StudentLeaveAdd
    },
    {
        path: '/StudentGoBack',
        component: StudentGoBack
    },
    {
        path: '/WGlist',
        component: WGlist
    },
    // {
    //     name:'WGmessage',
    //     path:'/WGmessage',
    //     component: () => import('@/views/WGmessage'),
    //     meta:{
    //         title:'消息提醒'
    //     }
    // },
    {
        path:'/UserInfo',
        component:UserInfo
    },
    {
        path:'/WeChatBack',
        component:WeChatBack
    },
    {
        path:'/err',
        component:Err
    },
    {
        path:'/UserImg',
        component:UserImg
    },
    {
        path:'/MyStudent',
        component:MyStudent
    },
    {
        name:'Windex',
        path:'/Windex',
        component: () => import('@/views/Windex'),
        meta:{
            title:'消息提醒'
        }
    },
    {
        name:'MyStudentList',
        path:'/MyStudentList',
        component:() => import('@/views/MyStudentList')
    },
    {
        name:'MyTeacher',
        path:'/MyTeacher',
        component:() => import('@/views/MyTeacher')
    },
    {
        name:'MySchool',
        path:'/MySchool',
        component:() => import('@/views/MySchool')
    },
    {
        name:'MySchoolList',
        path:'/MySchoolList',
        component:() => import('@/views/MySchoolList')
    },
    {
        name:'TeacherPass',
        path:'/TeacherPass',
        component:()=>import('@/views/TeacherPass')
    },
    {
        name:'TeacherImage',
        path:'/TeacherImage',
        component:()=>import('@/views/TeacherImage')
    },

];

const router = new Router({
    routes
  })
  
  export default router
// export default new Router({
//     routes
// })